"use client";

import Link from "next/link";
import { MapPin, Phone } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-border py-12 px-6 md:px-12 max-w-7xl mx-auto">
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row justify-between items-start gap-10">
        
        <div className="flex flex-col space-y-2 shrink-0">
          <p className="text-[16px] font-black tracking-[0.2em] text-foreground uppercase">
            FOLDA
          </p>
          <p className="text-[14px] font-medium tracking-widest text-muted-foreground uppercase">
            © {currentYear} All rights reserved.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          
          <div className="flex items-start space-x-3 max-w-xs">
            <MapPin size={22} className="text-fd-500 shrink-0" />
            <div className="flex flex-col space-y-1">
              <p className="text-[16px] font-black tracking-widest text-foreground uppercase opacity-50">
                Location
              </p>
              <p className="text-[14px] leading-relaxed text-muted-foreground font-medium">
                159/113 หมู่ที่ 2 ตำบลบ้านเกาะ <br />
                อ.พระนครศรีอยุธยา จ.พระนครศรีอยุธยา 13000
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <Phone size={18} className="text-fd-500 shrink-0 mt-1" />
            <div className="flex flex-col space-y-1">
              <p className="text-[16px] font-black tracking-widest text-foreground uppercase opacity-50">
                Contact
              </p>
              <a 
                href="tel:0801234567"
                className="text-[14px] font-bold text-muted-foreground hover:text-fd-500 transition-colors"
              >
                081-555-3558
              </a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}